import {Localize} from "@dp-instant/i18n";
import {Button} from "@dp-instant/ui";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import cn from "classnames";
import {playUIClickSound} from "@game/helpers";
import {hapticMedium} from "@game/haptic";

export const ContinueButton = ({onClick}: IClickableComponentProps) => (
    <Button
        className={cn("continue-button")}
        onClick={() => {
            if (onClick) {
                playUIClickSound();
                hapticMedium();
                onClick();
            }
        }}
    >
        {Localize.get("ui-win-continue", "CONTINUE")}
    </Button>
);
